module.exports = __webpack_public_path__ + "img/leftimagesentences.1f4bfee9.png";